import React from "react";
import { ChevronDown } from "lucide-react";

// Foldable settings card; shows a one-line summary while folded.
export const BuilderCard = ({ id, title, icon, summary, open, onToggle, children }) => (
  <section data-testid={`card-${id}`} className="paper rounded-sm bg-white">
    <button
      type="button"
      data-testid={`card-${id}-toggle`}
      aria-expanded={open}
      onClick={onToggle}
      className="w-full flex items-center gap-3 px-5 py-4 text-left min-h-[52px]"
    >
      {icon && <span className="text-neutral-500 shrink-0">{icon}</span>}
      <span className="min-w-0 flex-1">
        <span className="overline block">{title}</span>
        {!open && summary && (
          <span data-testid={`card-${id}-summary`} className="block text-xs text-neutral-500 truncate mt-0.5">
            {summary}
          </span>
        )}
      </span>
      <ChevronDown
        className={`w-4 h-4 text-neutral-400 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
      />
    </button>
    <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
      <div className="overflow-hidden" inert={!open}>
        <div className="px-5 pb-5 space-y-4">{children}</div>
      </div>
    </div>
  </section>
);

export const SubLabel = ({ icon, children, extra }) => (
  <div className="flex items-center gap-2 mb-1.5">
    {icon && <span className="text-neutral-500">{icon}</span>}
    <span className="text-[10px] uppercase tracking-widest text-neutral-500">{children}</span>
    {extra}
  </div>
);
